<template>
    <div
        class="d-flex flex-row flew-nowrap gap-2"
        v-if="value && value.length > 0"
    >
        <span
            v-for="(tag, i) in value"
            :key="i"
            class="badge fw-semibold h-100"
            :style="{
                'margin-top': '1px',
                'background-color': getColorByString(tag, 'nogray', 75).background,
                color: getColorByString(tag, 'nogray', 75).foreground,
                border: '1px solid ' + getColorByString(tag, 'nogray', 75).border,
            }"
        >
            <IconComp icon="fa-tag" />
            {{ $tm(tag) }}
        </span>
    </div>
</template>
<script setup lang="ts">
import { getColorByString } from '@/utilities';
import { IconComp } from '@/components';
import { $tm } from '@/locize';

/**
 * Will display a list of tags and also make sure each of them get a consistent color
 */

defineProps<{
    /**
     * The tags to display
     */
    value: string[] | null;
}>();
</script>
